<template>
  <div class="cancel-content" v-r-loading="loading">
    <div class="header-box" v-if="isH5">
      <PageMbHeader
        :title="applyProcess ? $t('取消订单进度') : $t('取消订单')"
        :transShow="false"
        :transOpen="false"
        @icon-click="back"
        :iconShow="!isNewTab"
      />
    </div>
    <HelpCenterHeader v-if="!isH5"></HelpCenterHeader>
    <template v-if="errCode">
      <EmptyState emptyType="noNetwork" @tryAgain="cancelDuty" />
    </template>
    <template v-else>
      <CancelOrderRatain
        v-if="!applyProcess"
        :cancelData="cancelData"
      ></CancelOrderRatain>
      <!-- 取消订单 -->
      <CancelOrderSchedule
        v-else
        :cancelData="cancelData"
      ></CancelOrderSchedule>
    </template>
  </div>
</template>

<script>
import api from '@/api';
import { mapState } from 'vuex';
import CancelOrderSchedule from './Schedule/index.vue';
import CancelOrderRatain from './Retain/index.vue';
import HelpCenterHeader from '@/components/HelpCenterHeader';
import PageMbHeader from '@/components/PageMbHeader';
import EmptyState from '@/components/EmptyState';
import { get } from 'lodash-es';
import { ERROR_CODE, REFRESH_TIME } from './const';
import { getIsNewTab } from '@/utils/tools';

export default {
  name: 'cancelOrder', // 取消订单
  components: {
    CancelOrderRatain,
    CancelOrderSchedule,
    HelpCenterHeader,
    PageMbHeader,
    EmptyState,
  },
  data() {
    return {
      // 预判责数据
      cancelData: {},
      loading: false,
      errCode: null,
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
    // 取消申请正在进行中
    applyProcess() {
      return +this.cancelData.applyProcess === 1;
    },
    isNewTab() {
      return getIsNewTab();
    },
  },
  methods: {
    // 取消订单预判责
    async cancelDuty() {
      try {
        this.loading = true;
        const orderId = get(this, '$route.query.orderId', '');
        const orderCityId = get(this, '$route.query.orderCityId', '');
        let data = {
          orderId,
          orderCityId,
        };
        const resData = (await api.cancelDuty(data)) || {};
        this.cancelData = resData;
        this.loading = false;
        this.errCode = null;
        const orderStatus = get(this, 'cancelData.order_status', '');
        this.$trackEvent({
          eventId: 'sailing_c_x_cancelorder_common_sw',
          eventLabel: '取消订单页面展示',
          attrs: {
            order_id: orderId,
            order_status: orderStatus,
          },
        });
      } catch (error) {
        const errno = get(error, 'errno', null);
        // 关闭订单已完成页面
        if (+errno === ERROR_CODE.ORDER_STATUS_UPDATE) {
          this.goOrderList();
        } else if (+errno === ERROR_CODE.INFO_UPDATE) {
          setTimeout(() => {
            this.cancelDuty();
          }, REFRESH_TIME);
        } else {
          this.errCode = errno;
          this.loading = false;
        }
      }
    },
    goOrderList() {
      this.$router.push({
        path: '/order/',
      });
    },
    back() {
      this.$router.go(-1);
    },
  },
  created() {
    this.cancelDuty();
  },
};
</script>

<style lang="scss" scoped>
.cancel-content {
  min-height: 470px;
  background: #f5f5f7;
}
</style>

<style lang="scss" scoped>
// 移动端适配
@media screen and (max-width: 768px) {
  .cancel-content {
    min-height: auto;
    background: transparent;
  }
  .header-box {
    position: sticky;
    top: 0;
    z-index: 9;
  }
  .cate-header-wrapper {
    position: relative;
  }
}
</style>
